import { useEffect, useState } from 'react';

// Countdown for the code step (seconds, or null when there is no code to enter).
// It pauses while a request is in flight and calls onExpire when it reaches zero,
// so the user isn't asked to send a code that would only come back expired.
export const useCodeCountdown = ({ loading, onExpire }) => {
  const [secondsLeft, setSecondsLeft] = useState(null);
  useEffect(() => {
    if (secondsLeft === null || loading) {
      return undefined;
    }
    if (secondsLeft <= 0) {
      onExpire();
      return undefined;
    }
    const timer = setTimeout(() => setSecondsLeft(left => left - 1), 1000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [secondsLeft, loading]);
  return [secondsLeft, setSecondsLeft];
};
